// @ts-nocheck
import { createBlueprint } from "@atlassiansox/bxp-content-framework";

import { models } from "./models";
import {
    Page,
    UiAccordion,
    UiAddToSlackSection,
    UiBlock,
    UiButton,
    UiCaption,
    UiCard,
    UiCarousel,
    UiColumn,
    UiContactForm,
    UiDownloadButton,
    UiEmailSignup,
    UiFeatureSection,
    UiFooterNav,
    UiGuide,
    UiHeaderNav,
    UiImage,
    UiImageSet,
    UiIntegration,
    UiIntegrationSection,
    UiLink,
    UiLinkBlock,
    UiListCarousel,
    UiLoginContainer,
    UiMarkdown,
    UiMarketoForm,
    UiModal,
    UiNavBanner,
    UiNavImages,
    UiNavLink,
    UiPowerUp,
    UiPricingCalculator,
    UiPricingGrid,
    UiQuote,
    UiRecommendShare,
    UiRotatingItems,
    UiSection,
    UiSocialShare,
    UiSpacer,
    UiSplitSection,
    UiStack,
    UiStatuspage,
    UiStoryline,
    UiTab,
    UiTabPanel,
    UiTemplateGallery,
    UiTextBlock,
    UiTooltip,
    UiTrelloBoard,
    UiValueProp,
    UiVariationContainer,
    UiVideo,
    UiVideoPlayer,
    UiWebinarLink,
    UiWorkspacePicker
} from "./views";

export const blueprint = createBlueprint({
    models,
    views: {
        page: Page,
        uiAccordion: UiAccordion,
        uiAddToSlackSection: UiAddToSlackSection,
        uiBlock: UiBlock,
        uiButton: UiButton,
        uiCaption: UiCaption,
        uiCard: UiCard,
        uiCarousel: UiCarousel,
        uiColumn: UiColumn,
        uiContactForm: UiContactForm,
        uiDownloadButton: UiDownloadButton,
        uiEmailSignup: UiEmailSignup,
        uiFeatureSection: UiFeatureSection,
        uiFooterNav: UiFooterNav,
        uiGuide: UiGuide,
        uiHeaderNav: UiHeaderNav,
        uiImage: UiImage,
        uiImageSet: UiImageSet,
        uiIntegration: UiIntegration,
        uiIntegrationSection: UiIntegrationSection,
        uiLink: UiLink,
        uiLinkBlock: UiLinkBlock,
        uiListCarousel: UiListCarousel,
        uiLoginContainer: UiLoginContainer,
        uiMarkdown: UiMarkdown,
        uiMarketoForm: UiMarketoForm,
        uiModal: UiModal,
        uiNavBanner: UiNavBanner,
        uiNavImages: UiNavImages,
        uiNavLink: UiNavLink,
        uiPowerUp: UiPowerUp,
        uiPricingCalculator: UiPricingCalculator,
        uiPricingGrid: UiPricingGrid,
        uiQuote: UiQuote,
        uiRecommendShare: UiRecommendShare,
        uiRotatingItems: UiRotatingItems,
        uiSection: UiSection,
        uiSocialShare: UiSocialShare,
        uiSpacer: UiSpacer,
        uiSplitSection: UiSplitSection,
        uiStack: UiStack,
        uiStatuspage: UiStatuspage,
        uiStoryline: UiStoryline,
        uiTab: UiTab,
        uiTabPanel: UiTabPanel,
        uiTemplateGallery: UiTemplateGallery,
        uiTextBlock: UiTextBlock,
        uiTooltip: UiTooltip,
        uiTrelloBoard: UiTrelloBoard,
        uiValueProp: UiValueProp,
        uiVariationContainer: UiVariationContainer,
        uiVideo: UiVideo,
        uiVideoPlayer: UiVideoPlayer,
        uiWebinarLink: UiWebinarLink,
        uiWorkspacePicker: UiWorkspacePicker
    },
    contentful: {
        spaceId: "rz1oowkt5gyp"
    }
});
